firebird.factory('videoLayoutPinService', [
    '$window',
    'logService',
    'configService',
    'videoGlobalService',
    function ($window, logService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoLayoutPinService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            $scope.$on('toggle-attendee-as-favorite', onToggleAttendeeAsFavorite);

            self.layoutPin = false;

            self.initLayoutPin = initLayoutPin;
            self.onToggleLayoutPin = onToggleLayoutPin;
            self.getLayoutPinnedForAttendee = getLayoutPinnedForAttendee;
            self.setLayoutPinnedVideos = setLayoutPinnedVideos;
            self.setLayoutPinOfVideo = setLayoutPinOfVideo;
        }

        // update layout pin from config
        function initLayoutPin() {
            self.layoutPin = configService.getValue('layoutPin') == 'true';
        }

        function onToggleAttendeeAsFavorite(evt, data) {
            if (!data || !data.attendantId) {
                logger.error('onToggleAttendeeAsFavorite', 'no attendee data to use for favorite pinning');
                return;
            }
            self.onToggleLayoutPin(data.attendantId, data.shouldPin);
        }

        function onToggleLayoutPin(fid, value) {
            // value is optional
            if (!self.layoutPin) {
                return;
            }

            self.logLayout('onToggleLayoutPin() ' + fid + ', ' + value);

            if (typeof fid === 'number') {
                fid = '' + fid;
            }

            var data = self.layoutPageData;
            var index = data.pinned.indexOf(fid);
            if (value === undefined) {
                value = index >= 0 ? false : true; // remove if exists, or add if not
            }

            var update = true;
            if (value && index < 0) {
                data.pinned.push(fid);
            } else if (!value && index >= 0) {
                data.pinned.splice(index, 1);
            } else {
                update = false; // no change
            }

            if (update && self.layoutPage) {
                // this update is specific within layoutPage flag.
                if (data.videos[fid] === undefined) {
                    self.logLayout('toggle layout pin - not in videos, id=' + fid);
                    return;
                }

                data.videos[fid].pinned = value;
                if (data.showPinnedLabel) {
                    if (value) {
                        data.videos[fid].div.setAttribute('pinned', true);
                    } else {
                        data.videos[fid].div.removeAttribute('pinned');
                    }
                }

                self.logLayout('video fid=' + fid + ' pinned=' + data.videos[fid].pinned);

                if (data.videos[fid].self) {
                    self.logLayout('videoroomCtrl - (un)pinning self video does not move in slots');
                } else if (value && data.pinnedCount < data.cutoff - data.pinnedFree) {
                    self.logLayout('videoLayoutPinService->onToggleLayoutPin set layoutPin of video, fid=' + fid);
                    self.setLayoutPinOfVideo(fid);
                } else if (!value) {
                    // move to after pinnedCount
                    data.pinnedCount--;
                    var index1 = data.slots.indexOf(fid);
                    if (index1 >= 0 && index1 < data.pinnedCount) {
                        // need to be swapped.
                        self.logLayout('videoroomCtrl - swap ' + index1 + ' and ' + data.pinnedCount);
                        var t = data.slots[data.pinnedCount];
                        data.slots[data.pinnedCount] = data.slots[index1];
                        data.slots[index1] = t;

                        // restore sorting of pinned items.
                        var array1 = data.slots.slice(0, data.pinnedCount);
                        array1.sort(function (a, b) {
                            var an = data.videos[a].sortName,
                                bn = data.videos[b].sortName;
                            return an < bn ? -1 : an > bn ? 1 : 0;
                        });
                        var array2 = [0, array1.length].concat(array1);
                        [].splice.apply(data.slots, array2);
                    } else {
                        // no need to move.
                        self.logLayout('videoroomCtrl - no need to move in toggle layout pin');
                        update = false;
                    }
                } else {
                    // no more space for new pin.
                    self.logLayout(
                        'videoroomCtrl - cannot set layout pin, as no more space or is self, fid=' +
                            fid +
                            ', count=' +
                            data.pinnedCount
                    );
                    update = false;
                }
            } else if (update && self.layoutPin) {
                var div1 = $window.$('#videoroom-videos > div[user="' + fid + '"]').get(0);
                if (div1 && data.showPinnedLabel) {
                    if (value) {
                        div1.setAttribute('pinned', true);
                    } else {
                        div1.removeAttribute('pinned');
                    }
                }
            } else {
                logService.log('videoroomCtrl - no change needed in toggle layout pin');
            }
            if (update) {
                self.logLayout('updated slots=' + data.slots.join(','));
                self.updateVideosLayout();
            } else {
                self.logLayout('not updated slots');
            }
        }

        function setLayoutPinnedVideos(videoDivs) {
            if (!self.layoutPin) {
                return 0;
            }

            var data = self.layoutPageData;
            var pinned = {};
            var found = false;
            data.pinned.forEach(function (fid) {
                pinned[fid] = true;
                found = true;
            });
            if (!found) {
                return 0;
            }

            var included = [];
            var fid2div = {};
            for (var i = videoDivs.length - 1; i >= 0; --i) {
                var div = videoDivs[i];
                var fid = div.getAttribute('user');
                if (pinned[fid]) {
                    fid2div[fid] = div;
                    included.push(fid);
                    videoDivs.splice(i, 1);
                }
            }
            if (!included.length) {
                return 0;
            }

            included.sort(function (a, b) {
                var an = fid2div[a].sortName,
                    bn = fid2div[b].sortName;
                return an < bn ? -1 : an > bn ? 1 : 0;
            });

            var divs = included.map(function (fid) {
                return fid2div[fid];
            });
            var result = divs.length;

            divs.splice(0, 0, 0, 0);
            [].splice.apply(videoDivs, divs);

            return result; // number of pinned items.
        }

        function getLayoutPinnedForAttendee(fid) {
            if (!self.layoutPin) {
                return false;
            }

            if (typeof fid === 'number') {
                fid = '' + fid;
            }

            var data = self.layoutPageData;
            var result = data.pinned.indexOf(fid) >= 0;
            return result;
        }

        function setLayoutPinOfVideo(fid) {
            if (!self.layoutPage) {
                return;
            }

            self.logLayout('setLayoutPinOfVideo() fid=' + fid);
            var data = self.layoutPageData;

            var array1 = data.slots.slice(0, data.pinnedCount); // existing
            var index = data.slots.indexOf(fid);
            if (index >= 0) {
                data.slots.splice(index, 1);
            }
            array1.push(fid);
            data.pinnedCount++;
            array1.sort(function (a, b) {
                var an = data.videos[a].sortName,
                    bn = data.videos[b].sortName;
                return an < bn ? -1 : an > bn ? 1 : 0;
            });
            var array2 = [0, array1.length - 1].concat(array1);
            [].splice.apply(data.slots, array2);

            if (self.layoutOrder && self.layoutOrder != 'id') {
                if (data.slots.length > data.cutoff) {
                    var fid1 = self.getLayoutPageRandomSlot();
                    if (fid1) {
                        var index1 = data.slots.indexOf(fid1);
                        data.slots.splice(index1, 1);
                        self.setLayoutPageVideoSlotted(fid1, false);
                        self.logLayout('removed random slot index=' + index1 + ' fid=' + fid1);
                    } else {
                        // revert previous actions
                        self.logLayout('cannot find a slot to replace pinned fid=' + fid);
                        var index2 = data.slots.indexOf(fid);
                        data.slots.splice(index2, 1);
                        data.pinnedCount--;
                        self.setLayoutPageVideoSlotted(fid, false);
                    }
                }
                self.onLayoutPageOrderedSlots();
            } else {
                if (index >= 0 && index >= data.pinnedCount) {
                    // swap with previous pinnedCount index
                    self.logLayout('swap at index ' + index + ' and ' + data.pinnedCount);
                    var previous = data.slots[data.pinnedCount];
                    data.slots.splice(data.pinnedCount, 1);
                    data.slots.splice(index, 0, previous);
                }

                if (data.slots.length > data.cutoff) {
                    // remove an item with oldest ts. search forward from pinned end
                    self.onLayoutPageRemoveOneSlot('forward');
                }
            }
        }
    }
]);
